export default "__VITE_ASSET__2b41adf0__"